import { authApi, setAccessDenied } from 'api/auth';
import { resetCalculationSession as resetCalculationStore } from 'api/calc';
import type { AppDispatch } from 'store';

export const resetCalculationSession = (dispatch: AppDispatch) => {
  resetCalculationStore(dispatch);
  dispatch(setAccessDenied(false));
};

/** Полный сброс клиентского состояния при смене пользователя без перезагрузки страницы. */
export const resetAppSessionForNewUser = (dispatch: AppDispatch) => {
  resetCalculationSession(dispatch);
  dispatch(authApi.util.resetApiState());
};
